import React from "react";

import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
  Line,
  Font,
} from "@react-pdf/renderer";
import { useLocation, useParams } from "react-router-dom";
import { Backdrop, Typography } from "@mui/material";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

// Inter
Font.register({
  family: "Inter",
  src: "/fonts/QS97R-6RI6D (2).ttf", // note the leading slash
  fontWeight: "bold",
});

Font.register({
  family: "Inter",
  src: "/fonts/AltisUniSA-Regular.ttf", // note the leading slash
  fontWeight: "normal",
});

// Font.register({
//   family: "Inter",
//   src: "/fonts/Inter-Medium.otf", // note the leading slash
//   fontWeight: "Medium",
// });

// Font.register({
//   family: "Inter",
//   src: "/fonts/Inter-SemiBold.otf", // note the leading slash
//   fontWeight: "Semi Bold",
// });

// Font.register({
//   family: "Inter",
//   src: "/fonts/Inter-Bold.otf", // note the leading slash
//   fontWeight: "Semi Bold",
// });
// Register Inter font from a CDN or Google Fonts URL

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
  },
  logo: {
    width: 75,
  },
  section: {
    margin: 1,
    padding: 1,
    flexGrow: 0.1,
  },

  header: {
    fontSize: 16,
    fontWeight: 600,

    color: "#000000",
    fontFamily: "Inter",
  },

  subheader: {
    fontSize: 12,
    fontWeight: 400,
    marginTop: "5px",
    color: "#0000000",
    fontFamily: "Inter",
  },
  totalText: {
    marginTop: "7px",
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Inter",
    color: "#000000",
  },

  text: {
    fontSize: 14,
    fontWeight: 400,
    color: "#000000",
    marginTop: "5px",
    fontFamily: "Inter",
  },

  hrLine: {
    width: "100%",
    borderBottomColor: "#B8AEBE",
    borderBottomWidth: 1,
    marginTop: 10,
  },

  nameTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: "#000000",
    fontFamily: "Inter",
  },

  subNameTitle: {
    fontSize: 12,
    fontWeight: 400,

    color: "#000000",
    fontFamily: "Inter",
  },

  // table css
  tableContainer: {
    marginTop: 50,
    borderTop: "1pt solid #3D1C52",

    borderRadius: 2,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "1pt solid #3D1C52",

    fontSize: 12,
    fontWeight: 700,
    fontFamily: "Inter",
    color: "#000000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1pt solid #3D1C52",
    minHeight: 40,
    fontSize: 10,
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#232122",
  },
  tableCell: {
    padding: 8,
  },
  colIndex: {
    width: "5%",
    backgroundColor: "#F8EEFF",
  },
  colDescription: {
    width: "75%",
    marginLeft: "10px",
  },
  colSubtotal: {
    width: "20%",
    textAlign: "right",
    backgroundColor: "#F8EEFF",
    fontWeight: "bold",
  },
  totalContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 5,
  },
  totalLabel: {
    fontSize: 11,
    fontWeight: "bold",
  },
  totalValue: {
    fontSize: 11,
    fontWeight: "bold",
    marginLeft: 5,
  },
});

export const ViewPaymentInvoice = ({ receiptData }) => {
  let currDate = new Date().toISOString().split("T")[0];
  const firstName = localStorage.getItem("firstName");
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Image
              style={styles.logo}
              src="/newdashboard/Payment History/stm-logo-dark 1 (1).png"
            />
            <View>
              <Text
                style={{ ...styles.header, fontWeight: 600, fontSize: "18px" }}
              >
                Receipt
              </Text>
              <Text style={{ ...styles.text }}>
                {receiptData?.receipt_number}
              </Text>
            </View>
          </View>

          <View style={{ marginTop: 40, fontSize: 16 }}>
            <Text style={styles.header}>Billing Details</Text>
          </View>
          <View
            style={{
              marginTop: 10,
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {/* Left Section */}
            <View
              style={{
                flexDirection: "column",
                width: "50%",
              }}
            >
              {/* Billed To Name */}
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Text style={{ width: 80, ...styles.nameTitle }}>
                  Billed To
                </Text>
                <Text style={styles.nameTitle}>: </Text>
                <Text style={styles.subNameTitle}>
                  {" "}
                  {receiptData?.provisional_payments_id?.billing_address_id
                    ?.name || firstName}
                </Text>
              </View>

              {/* Billed To Address */}
              <View
                style={{ marginTop: 5, flexDirection: "row", flexWrap: "wrap" }}
              >
                <Text style={{ width: 80, ...styles.nameTitle }}>Address</Text>
                <Text style={styles.nameTitle}>: </Text>
                <View style={{ flex: 1, lineHeight: 1.4 }}>
                  <Text style={styles.subNameTitle}>
                    {"  "}{" "}
                    {receiptData?.provisional_payments_id?.billing_address_id
                      ?.address || "-"}
                    ,{" "}
                    {receiptData?.provisional_payments_id?.billing_address_id
                      ?.state_id?.state_name || "-"}
                    ,{" "}
                    {receiptData?.provisional_payments_id?.billing_address_id
                      ?.city_id?.city_name || "-"}
                    ,{" "}
                    {receiptData?.provisional_payments_id?.billing_address_id
                      ?.zip_code || "-"}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{
                flexDirection: "column",
              }}
            >
              {/* Billed To Name */}
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Text style={{ width: 80, ...styles.nameTitle }}>
                  Receipt Date
                </Text>
                <Text style={styles.nameTitle}>: </Text>
                <Text style={styles.subNameTitle}> {currDate}</Text>
              </View>

              {/* Billed To Address */}
              <View
                style={{ marginTop: 5, flexDirection: "row", flexWrap: "wrap" }}
              >
                <Text style={{ width: 80, ...styles.nameTitle }}>
                  Paid Date
                </Text>
                <Text style={styles.nameTitle}>: </Text>
                <Text style={styles.subNameTitle}>
                  {" "}
                  {receiptData?.paid_date}
                </Text>
              </View>
            </View>
          </View>

          <View style={{ marginTop: 20, fontSize: 14 }}>
            <Text style={styles.header}>Branch Details</Text>
          </View>
          <View style={{ marginTop: 10 }}>
            <View
              style={{
                flexDirection: "column",

                // alignItems: "flex-end", // aligns all items to right
              }}
            >
              {/* Billed From Name */}
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Text style={{ width: 80, ...styles.nameTitle }}>
                  Billed From{" "}
                </Text>
                <Text style={styles.nameTitle}>: </Text>
                <Text style={styles.subNameTitle}>
                  {" "}
                  {receiptData?.billed_from}
                </Text>
              </View>

              {/* Branch */}
              <View
                style={{
                  marginTop: 5,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Text style={{ width: 80, ...styles.nameTitle }}>Branch </Text>
                <Text style={styles.nameTitle}>: </Text>
                <Text style={styles.subNameTitle}>
                  {" "}
                  {receiptData?.stm_head_branch}
                </Text>
              </View>

              {/* Address */}
              <View
                style={{ marginTop: 5, flexDirection: "row", flexWrap: "wrap" }}
              >
                <Text style={{ width: 80, ...styles.nameTitle }}>Address</Text>
                <Text style={styles.nameTitle}>: </Text>
                <Text style={styles.subNameTitle}>
                  {" "}
                  {receiptData?.contact_address}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* Receipt Table Section */}
        <View style={styles.tableContainer}>
          {/* Table Header */}
          <View style={styles.tableHeader}>
            <Text style={[styles.tableCell, styles.colIndex]}>#</Text>
            <Text style={[styles.tableCell, styles.colDescription]}>
              Title/Description
            </Text>
            <Text style={[styles.tableCell, styles.colSubtotal]}>Subtotal</Text>
          </View>

          {/* Table Row */}
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.colIndex]}>1</Text>
            <View style={[styles.tableCell, styles.colDescription]}>
              <Text
                style={{
                  textAlign: "left",
                  color: "#000000",
                  fontWeight: 400,
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontSize: 12,
                }}
              >
                {receiptData?.class_id?.name}
                {"  "}
                <Text style={{ color: "#474747", fontWeight: 400 }}>
                  {receiptData?.provisional_payments_id?.is_class_extension
                    ? "[ Class Extension ]"
                    : ` ${receiptData?.package_id?.package_name} `}
                </Text>
              </Text>

              <Text
                style={{
                  textAlign: "left",
                  color: "#000000",
                  fontWeight: 400,
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  marginTop: 10,
                  fontSize: 12,
                }}
              >
                {receiptData?.tax_name} {receiptData?.gst_percentage} %{"  "}
              </Text>
            </View>

            <View style={[styles.tableCell, styles.colSubtotal]}>
              <Text
                style={{
                  fontWeight: 600,
                  textAlign: "right",
                  fontSize: 12,
                  color: "#000000",
                }}
              >
                {receiptData?.currency}{" "}
                {receiptData?.paid_amount - receiptData?.gst_amount}
              </Text>
              <Text
                style={{
                  textAlign: "right",
                  fontWeight: 600,
                  marginTop: 10,
                  fontSize: 12,
                  color: "#000000",
                }}
              >
                {receiptData?.currency} {receiptData?.gst_amount}
              </Text>
            </View>
          </View>
        </View>

        <View
          style={{
            ...styles.section,
            flexDirection: "row",
            justifyContent: "flex-end",
            marginLeft: 10,
            padding: 0,
          }}
        >
          <Text style={{ ...styles.totalText }}>Total </Text>
          <Text
            style={{
              ...styles.totalText,
              width: "20%",
              textAlign: "right",
              paddingRight: 8,
            }}
          >
            {" "}
            {receiptData?.currency} {receiptData?.paid_amount}
          </Text>
        </View>

        <View style={{ ...styles.section, marginTop: "10px" }}>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: "150px",
            }}
          >
            <Text style={{ ...styles.subheader, marginRight: "15px" }}>
              Payment Info
            </Text>

            <Line style={styles.hrLine} />
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: "10px",
              width: "100%",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                flex: 1, // <-- This makes it take the full width
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "column",

                  alignItems: "center",
                  rowGap: 8,
                }}
              >
                <Text style={styles.nameTitle}>Ref Number </Text>
                <Text style={{ ...styles.subNameTitle }}>
                  {receiptData?.ref_number}
                </Text>
              </View>

              <View
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  rowGap: 8,
                }}
              >
                <Text style={styles.nameTitle}>Payment Method </Text>
                <Text style={{ ...styles.subNameTitle }}>
                  {receiptData?.payment_method?.payment_mode}
                </Text>
              </View>

              <View
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  rowGap: 8,
                }}
              >
                <Text style={styles.nameTitle}>GST Number </Text>
                <Text style={{ ...styles.subNameTitle }}>
                  {receiptData?.gst_number}
                </Text>
              </View>

              <View
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  rowGap: 5,
                }}
              >
                <Text style={styles.nameTitle}>Payment Status </Text>
                <Text style={{ ...styles.subNameTitle }}>Paid</Text>
              </View>
            </View>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            // alignItems: "center",
            marginTop: 10,
          }}
        >
          <View style={{ width: 12, height: 12 }}>
            <Image
              src="/newdashboard/Payment History/Group 1171284037 (1).png" // Use a valid image path
              style={{ width: "100%" }}
            />
          </View>
          <Text
            style={{
              color: "#858585",
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: 10,
              marginLeft: 6,
            }}
          >
            NOTE: Scholastic Test Masters does not have a refund policy under
            any circumstances.
          </Text>
        </View>

        <Line style={styles.hrLine} />

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 5,
            width: "100%", // important!
            rowGap: 10,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              flex: 1,
            }}
          >
            <View style={{ width: 15 }}>
              <Image
                src="/newdashboard/Payment History/Group 1171284123 (1).png" // Use a valid image path
              />
            </View>
            <Text
              style={{
                color: "#000000",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: 12,
                marginLeft: 6,
              }}
            >
              {receiptData?.contact_number}
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              flex: 1,
            }}
          >
            <View style={{ width: 15, flexShrink: 0 }}>
              <Image
                src="/newdashboard/Payment History/Group 1171284124 (1).png" // Use a valid image path
                // style={{ width: 10, height: 10, marginTop: 1.5 }}
              />
            </View>
            <Text
              style={{
                color: "#000000",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: 12,
                marginLeft: 6,
              }}
            >
              {receiptData?.contact_email}
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              flex: 1,
              width: "100%",
            }}
          >
            <View style={{ width: 15, height: 15, flexShrink: 0 }}>
              {" "}
              <Image
                src="/newdashboard/Payment History/Group 1171284125 (1).png" // Use a valid image path
                style={{ width: "100%", height: "100%" }}
              />
            </View>

            <Text
              style={{
                color: "#000000",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: 12,
                marginLeft: 6,
                lineHeight: 1.4,
              }}
            >
              {receiptData?.contact_address}
            </Text>
          </View>
        </View>

        <View
          style={{
            position: "absolute",
            bottom: 0,
            //  left: 0,
            // right:0,
            width: "200%",
            height: 30,

            backgroundColor: "#572575",
          }}
        >
          <Text></Text>
        </View>
      </Page>
    </Document>
  );
};

// export default function PaymentInvoice() {
//   const location = useLocation();
//   const { receiptData } = location.state || {};

//   console.log("receiptData", receiptData);
//   return (
//     <PDFViewer style={{ width: "100%", height: "100vh" }}>
//       <ViewPaymentInvoice receiptData={receiptData} />
//     </PDFViewer>
//   );
// }
// export default ViewPaymentInvoice;
